import { getTenant, GRAB } from '../Tenants';

export const tenantAppOptionsMap = {
  grab: {
    pax: 'Pax',
    dax: 'Dax',
    mex: 'Mex',
    pos: 'Pos',
  },
  gxs: {
    gxs: 'Gxs',
  },
  gxb: {
    gxb: 'Gxb',
  },
  moveit: {
    moveitpax: 'MoveITPax',
    moveitdax: 'MoveITDax',
  },
};

export const osOptionsMap = {
  ios: 'iOS',
  adr: 'Android',
};

export const versionRegx = /^\d+\.\d+\.\d+$/;

export const getAppOptionsMap = (tenant: string) => {
  return tenantAppOptionsMap[tenant]
    ? tenantAppOptionsMap[tenant]
    : tenantAppOptionsMap[GRAB];
};

function unifyOS(value: string) {
  if (value === 'android') {
    return 'adr';
  }
  return value;
}

export const parseAppVersion = (value: string) => {
  if (!value) return ['', '', ''];

  const values = value.split('-');

  if (values?.length !== 3) {
    return ['', '', ''];
  }

  return [values[0], unifyOS(values[1]), values[2]];
};

export const isValidAppVersion = (value: string) => {
  const [app, os, version] = parseAppVersion(value);
  const appOptionsMap = getAppOptionsMap(getTenant());
  return (
    !!appOptionsMap[app] && !!osOptionsMap[os] && versionRegx.test(version)
  );
};

export const splitAppVersionString = (value: string): string[] => {
  return value?.split(',')?.filter((part) => !!part);
};
